// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container, Form } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import BookingService from 'services/BookingService';
import InvoiceService from 'services/InvoiceService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';
import BookingInvoiceModal from 'components/invoicing/BookingInvoiceModal';
import BookingsTable from 'components/bookings/BookingsTable';
import PageHeader from 'components/common/PageHeader';
import SideBar from 'components/common/SideBar';

//-------------------------------------------------------------------------------------------------------------------

class BillsPage extends React.Component {

    constructor(props) {
        super(props);

        this.bookingInvoiceModalRef = React.createRef();

        this.requestID = 1;

        this.state = {
            isLoading: true,
            filters: {
                goCoursesInvoiceStatus: 'Due',
                vendorPaidMonth: null,
                goCoursesPaidMonth: null,
                vendorInvoiceStatus: null
            }
        };
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        this.load();
    }

    componentDidUpdate(oldProps) {
        const oldParams = this.getParams(oldProps.match.params);
        const newParams = this.getParams(this.props.match.params);
        if (newParams.slug != oldParams.slug || newParams.tab != oldParams.tab) {
            this.load();
        }
    }
    
    getParams(params) {
        if (typeof (params) == 'undefined') {
            params = this.props.match.params;
        }
        let { slug } = params;
        if (slug == 'null') {
            slug = '';
        }
        return {
            slug: (slug || '')
        };
    }

    async load() {
        this.setState({
            isLoading: true,
            numSelected: 0
        });
        const {
            filters
        } = this.state;

        GlobalStateService.setValues({
            area: 'invoicing'
        });

        this.requestID++;

        const newState = {};

        // Load bookings/invoices
        newState.bookings = await BookingService.list({
            instructorID: null,
            isInvoicing: true,
            includeNonATP: true,
            includeATP: true,
            ...filters
        });
        newState.isLoading = false;

        // Load paid months
        if (filters.goCoursesInvoiceStatus == 'Paid') {
            newState.paidMonths = await BookingService.listPaidMonths({
                instructorID: null,
                isInvoicing: true,
                includeNonATP: true,
                includeATP: true,
                ...filters
            });
            newState.paidMonths.vendor = [{ value: '', text: '(Any date)' }].concat(newState.paidMonths.vendor);
            newState.paidMonths.goCourses = [{ value: '', text: '(Any)' }].concat(newState.paidMonths.goCourses);
        }   
        
        newState.isLoading = false;
        this.setState(newState);
    }

    updateFilter(name, value) {
        const filters = { ...this.state.filters };
        if (filters[name] != value) {
            filters[name] = value;

            this.setState({
                filters: filters,
                isLoading: true
            }, () => {

                switch (name) {
                    case 'goCoursesInvoiceStatus':
                    case 'dateGoCoursesPaid':
                    case 'vendorInvoiceStatus':
                        this.load();
                        break;
                    default:
                        this.setState({ isLoading: false });
                        break;
                }

            });
        }
    }

    setBookingIsSelected(id, isSelected) {
        const bookings = [...this.state.bookings];
        const index = bookings.findIndex(b => b.id == id);
        bookings[index].isSelected = isSelected;
        this.requestID++;
        this.setState({
            bookings,
            numSelected: this.countNumSelected(bookings)
        });
    }

    selectAllBookings() {
        const bookings = [...this.state.bookings];
        bookings.forEach(booking => {
            booking.isSelected = true;
        });
        this.requestID++;
        this.setState({
            bookings,
            numSelected: this.countNumSelected(bookings)
        });
    }

    countNumSelected(bookings) {
        let numSelected = 0;
        bookings.forEach(b => {
            if (b.isSelected) {
                numSelected++;
            }
        });
        return numSelected;
    }

    downloadPaymentsCSV() {
        const { bookings } = this.state;
        const bookingIDs = [];
        bookings.forEach(booking => {
            if (booking.isSelected && booking.bill) {
                bookingIDs.push(booking.id);
            }
        });
        window.open(
            '/api/invoice/get-invoice-payments-csv' + (bookingIDs.length > 0 ? '?bookingIDs=' + bookingIDs.join(',') : '')
        );
        if (bookingIDs.length == 0) {
            this.selectAllBookings();
        }
    }

    async markSelectedAsPaid() {
        const { numSelected, bookings } = this.state;
        const confirm = await BootboxHelper.confirm(`Mark ${numSelected} bill(s) as paid?`)
        if (confirm) {
            this.setState({ isLoading: true });
            const invoiceIDs = [];
            bookings.forEach(booking => {
                if (booking.isSelected && booking.bill) {
                    invoiceIDs.push(booking.bill.id);
                }
            });
            await InvoiceService.markAsPaid(invoiceIDs);
            this.load();
        }
    }

    async copyLMSIDs(grouping) {
        const bookings = [...this.state.bookings];
        const lmsIDs = [];
        grouping.bookings.forEach(b => {
            if (b.lmsid) {
                lmsIDs.push(b.lmsid);
            }
            const index = bookings.findIndex(b2 => b2.id == b.id);
            bookings[index].isSelected = true;
        });
        await navigator.clipboard.writeText(lmsIDs.join(', '));
        
        // Tick all bookings
        this.requestID++;
        this.setState({
            bookings,
            numSelected: this.countNumSelected(bookings)
        });
    }

    render() {
        const {
            filters, bookings, numSelected
        } = this.state;

        return (<>

            <div className="page bills-page full-width-page">

                <PageHeader hasSideBar>
                    <h1>Bills</h1>

                    <div className="buttons">

                        {filters.goCoursesInvoiceStatus == 'Due' && bookings && bookings.length > 0 &&
                            <button type="button" className="btn btn-primary" onClick={() => this.downloadPaymentsCSV()}>
                                Download CSV ({numSelected > 0 ? numSelected : 'all'})
                            </button>
                        }

                        {numSelected > 0 &&
                            <button type="button" className="btn btn-primary" onClick={() => this.markSelectedAsPaid()}>
                                Mark Paid ({numSelected})
                            </button>
                        }

                    </div>
                </PageHeader>

                <main>

                    <SideBar content={this.renderSideBarContent()} />

                    <Container fluid>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <BookingInvoiceModal ref={this.bookingInvoiceModalRef} />

        </>);
    }

    renderInner() {
        const {
            isLoading,
            bookings,
            filters
        } = this.state;

        if (isLoading) {
            return (<Loader fullPage />);
        }

        const groupings = {};

        // Group by payee
        if (filters.goCoursesInvoiceStatus == 'Due') {
            bookings.forEach(b => {
                const key = (b.subAgency ? b.subAgency.name : b.instructorName);
                if (!groupings[key]) {
                    groupings[key] = {
                        key,
                        total: 0,
                        paymentType: b.paymentType,
                        bookings: []
                    };
                }
                const grouping = groupings[key];
                grouping.bookings.push(b);
                grouping.total += b.cost;
                if (b.currency) {
                    if (!grouping.currency) {
                        grouping.currency = b.currency;
                    }
                    else if (grouping.currency.code != b.currency.code) {
                        grouping.isDifferentCurrencies = true;
                    }
                }
            });
            Object.keys(groupings).forEach(g => {
                groupings[g].bookings.sort((a, b) => b.instructorName > a.instructorName ? 1 : b.instructorName < a.instructorName ? -1 : 0);
            });
        } else {
            groupings[''] = { bookings };
        }

        return Object.values(groupings).map(grouping =>
            <React.Fragment key={grouping.key}>
                {grouping.key &&
                    <h2>
                        {grouping.key}{' '}
                        {grouping.isDifferentCurrencies ?
                            <>(Different currencies)</> :
                            <>({grouping.total}{' '}{grouping.currency ? grouping.currency.code : ''})</>
                        }
                        {grouping.paymentType && <>
                            {' '}- {grouping.paymentType}
                        </>}
                        <button type="button" className="btn" onClick={() => this.copyLMSIDs(grouping)}>
                            <span className="fa fa-copy"></span>{' '}
                            Copy LMSIDs
                        </button>
                    </h2>
                }
                <BookingsTable
                    mode="bills"
                    className="admin-mode"
                    goCoursesInvoiceStatus={filters.goCoursesInvoiceStatus}
                    requestID={this.requestID}
                    bookings={grouping.bookings}
                    isEditMode
                    isScrolling
                    isSelecting={filters.goCoursesInvoiceStatus == 'Due'}
                    toggleSelected={(id, isSelected) => this.setBookingIsSelected(id, isSelected)}
                    getIsSelectable={booking => true}
                    onClick={async (booking) => {
                        await this.bookingInvoiceModalRef.current.show({
                            bookingID: booking.id
                        });
                        this.load();
                    }}
                />
            </React.Fragment>
        );
    }

    renderSideBarContent() {
        const {
            filters,
            paidMonths
        } = this.state;

        return (<>

            <Form.Group className="mb-3">
                <Form.Label>Bill Status</Form.Label>
                <select
                    className="form-control"
                    value={filters.goCoursesInvoiceStatus}
                    onChange={e => this.updateFilter('goCoursesInvoiceStatus', e.target.value)}
                >
                    <option value="">(Any status)</option>
                    {/*<option value="NotPaid">Bill received</option>*/}
                    <option value="Paid">Paid</option>
                    <option value="Due">Due for payment</option>
                    <option value="Archived">Archived</option>
                </select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Other options</Form.Label>
                <Form.Check
                    type="checkbox"
                    id="vendorInvoiceStatus"
                    checked={filters.vendorInvoiceStatus}
                    onChange={e => this.updateFilter('vendorInvoiceStatus', (e.target.checked ? 'paid' : null))}
                    label="Vendor paid only"
                />
            </Form.Group>

            {filters.goCoursesInvoiceStatus == 'Paid' && paidMonths &&
                <Form.Group className="mb-3">
                    <Form.Label>Paid in</Form.Label>
                    <select
                        className="form-control"
                        value={filters.dateGoCoursesPaid}
                        onChange={e => this.updateFilter('dateGoCoursesPaid', e.target.value)}
                    >
                        {paidMonths.goCourses.map(month =>
                            <option key={month.value} value={month.value}>
                                {month.text}
                            </option>
                        )}
                    </select>
                </Form.Group>
            }
            
        </>);
    }

}

export default withRouter(BillsPage);